import React from 'react';
import { Box, Text, Cluster, Checkbox } from '@thecb/components';
import { SearchResultItem } from './SearchResultItem';
import { useSelector } from 'react-redux';

export const SearchResultsTable = ({ selected, data = [], actions }) => {
  const items = data;
  const { tableHeaders } = useSelector((state) => state.searchResults.data);
  const currentProduct = useSelector((state) => state.products.currentProduct);
  const { accepts_overpayment, accepts_underpayment, annotation_allowed } =
    currentProduct.product_data;
  const annotationFields = annotation_allowed
    ? currentProduct.annotation_fields || []
    : [];
  const renderColumnHeaders = () => (
    <Box padding=".25rem">
      <Cluster direction="row" justify="space-between" align="center" nowrap>
        <Box padding="8px 0px 0px 8px">
          <Checkbox
            id="select-all"
            name="select-all"
            checked={selected.length === items.length}
            onChange={actions.toggleSelectAll}
          />
        </Box>
        {tableHeaders.map((th, idx) => (
          <Box
            key={`${th}-${idx}`}
            width="115px"
            padding="0 8px 0 0"
            extraStyles={'overflow-wrap: break-word; overflow: hidden;'}
          >
            <Text variant="p">{th}</Text>
          </Box>
        ))}
        {annotationFields.map((field) => (
          <Box key={field.name} padding="0 8px 0 0" width="200px">
            <Text variant="p">{field.display_name}</Text>
          </Box>
        ))}
        <Box width="95px" padding="0">
          <Text variant="p">Amount</Text>
        </Box>
        {(accepts_overpayment || accepts_underpayment) && (
          <Box padding="0" width="70px" id="edit-amount-column-header">
            {/* 
              If both accepts over/under payment are false, dont show the Edit Amount column at all because the user cant modify the data
              If one is true, leave empty space for the PencilIcon column that allows for editing of the Amount field 
            */}
          </Box>
        )}
      </Cluster>
    </Box>
  );

  return (
    <Box padding="1rem 0">
      {renderColumnHeaders()}
      {items.map((item) => (
        <SearchResultItem
          key={item.uniqueId}
          item={item}
          checked={Boolean(item.selected)}
          onCheckBoxClick={() => actions.toggleResultSelect(item.uniqueId)}
          handleAmountUpdate={actions.updateResultAmount}
          handleAnnotationUpdate={actions.updateResultAnnotation}
          annotationFields={annotationFields}
        />
      ))}
    </Box>
  );
};
